import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("pg_token");
    if (!token) { setUser(null); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
    } catch {
      localStorage.removeItem("pg_token");
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (phone, password) => {
    const r = await api.post("/auth/login", { phone, password });
    localStorage.setItem("pg_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("pg_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pg_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
